var _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFinanceIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 29.4006 28.482779",
    x: "0px",
    y: "0px",
    id: "svg20",
    width: 29.4006,
    height: 28.482779,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs33"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-32.863506,-975.12743)",
    id: "g14"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: "normal",
      fontStretch: "normal",
      fontSize: "medium",
      lineHeight: "normal",
      fontFamily: "sans-serif",
      textIndent: 0,
      textAlign: "start",
      textDecoration: "none",
      textDecorationLine: "none",
      textDecorationStyle: "solid",
      textDecorationColor: "#000000",
      letterSpacing: "normal",
      wordSpacing: "normal",
      textTransform: "none",
      writingMode: "lr-tb",
      direction: "ltr",
      baselineShift: "baseline",
      textAnchor: "start",
      whiteSpace: "normal",
      clipRule: "nonzero",
      display: "inline",
      overflow: "visible",
      visibility: "visible",
      opacity: 1,
      isolation: "auto",
      mixBlendMode: "normal",
      colorInterpolation: "sRGB",
      colorInterpolationFilters: "linearRGB",
      solidColor: "#000000",
      solidOpacity: 1,
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 2,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      colorRendering: "auto",
      imageRendering: "auto",
      shapeRendering: "auto",
      textRendering: "auto",
      enableBackground: "accumulate"
    },
    d: "m 50.734957,975.12851 c -1.471059,0.0185 -2.955789,0.26565 -4.400387,0.75683 -4.2306,1.43841 -7.431149,4.74931 -8.847523,8.81151 H 34.86716 l -1.719201,3.69039 h 3.607748 c -0.02426,0.33718 -0.07953,0.6673 -0.07953,1.00909 0,0.35214 0.06086,0.69082 0.08673,1.03791 h -2.324411 l -1.57499,3.69039 h 4.659848 c 1.439894,4.0401 4.642208,7.32967 8.865751,8.74667 5.785597,1.9411 12.18449,-0.029 15.875001,-4.89048 l -2.940648,-2.23083 c -2.741606,3.61086 -7.461432,5.06391 -11.759652,3.62193 -2.697946,-0.9052 -4.837575,-2.82477 -6.061522,-5.24729 h 13.964844 l 1.571168,-3.69039 H 40.453124 c -0.03513,-0.34752 -0.08673,-0.69013 -0.08673,-1.04512 0,-0.33956 0.04807,-0.66895 0.07938,-1.00188 h 17.43926 l 1.719053,-3.69039 H 41.465828 c 1.209688,-2.4499 3.345936,-4.39738 6.058141,-5.31934 4.29234,-1.45937 9.017899,-0.024 11.773911,3.57506 l 2.929917,-2.24164 c -2.782326,-3.6341 -7.079959,-5.63686 -11.492842,-5.58242 z",
    id: "path12"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFinanceIcon);
export default __webpack_public_path__ + "static/media/finance-icon.3549e482.svg";
export { ForwardRef as ReactComponent };